import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";

const BASE = "/farmasi/fornas-compliance";
const CATALOG_BASE = "/farmasi/fornas-drug-catalog";
const REPORT_BASE = "/farmasi/fornas-reports";

// --- Reason Definitions ---

async function getReasonDefinitions() {
  const response = await http
    .getData("/farmasi/fornas-reason-definitions")
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Evaluation CRUD ---

async function getEvaluations(params?: any) {
  const response = await http
    .getDataParam(BASE, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getEvaluation(id: number) {
  const response = await http
    .getData(`${BASE}/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function createEvaluation(data: any) {
  const response = await http
    .postData(BASE, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateEvaluation(id: number, data: any) {
  const response = await http
    .putData(`${BASE}/${id}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteEvaluation(id: number) {
  const response = await http
    .deleteData(`${BASE}/${id}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Evaluation Items ---

async function addItem(evalId: number, data: any) {
  const response = await http
    .postData(`${BASE}/${evalId}/items`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateItem(evalId: number, itemId: number, data: any) {
  const response = await http
    .putData(`${BASE}/${evalId}/items/${itemId}`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function deleteItem(evalId: number, itemId: number) {
  const response = await http
    .deleteData(`${BASE}/${evalId}/items/${itemId}`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Tarik dari Resep (kandidat) ---

async function getResepCandidates(params?: any) {
  const response = await http
    .getDataParam(`${BASE}/resep-candidates`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Document Upload ---

async function uploadDocument(evalId: number, formData: FormData) {
  const response = await http
    .postData(`${BASE}/${evalId}/upload-document`, formData)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- 3-Tier Signing ---

async function signPencatat(id: number, password: string) {
  const response = await http
    .putData(`${BASE}/${id}/sign-pencatat`, { password })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKaIfrs(id: number, password: string) {
  const response = await http
    .putData(`${BASE}/${id}/sign-ka-ifrs`, { password })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signApprover(id: number, password: string) {
  const response = await http
    .putData(`${BASE}/${id}/sign-approver`, { password })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- PDF ---

function getPdfUrl(id: number): string {
  return `${http.apiUrl}${BASE}/${id}/pdf`;
}

// --- Drug Catalog ---

async function getDrugCatalog(params?: any) {
  const response = await http
    .getDataParam(CATALOG_BASE, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getActiveVersion() {
  const response = await http
    .getData(`${CATALOG_BASE}/active-version`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

// --- Reports ---

async function getDailyRekap(params: any) {
  const response = await http
    .getDataParam(`${REPORT_BASE}/daily-rekap`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getDailyBreakdown(params: any) {
  const response = await http
    .getDataParam(`${REPORT_BASE}/daily-breakdown`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getMonthlyReport(params: any) {
  const response = await http
    .getDataParam(`${REPORT_BASE}/monthly`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getScorecard(params: any) {
  const response = await http
    .getDataParam(`${REPORT_BASE}/scorecard`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getMyScorecard(params: any) {
  const response = await http
    .getDataParam(`${REPORT_BASE}/my-scorecard`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function getTrend(params: any) {
  const response = await http
    .getDataParam(`${REPORT_BASE}/trend`, { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

export default {
  getReasonDefinitions,
  getEvaluations,
  getEvaluation,
  createEvaluation,
  updateEvaluation,
  deleteEvaluation,
  addItem,
  updateItem,
  deleteItem,
  getResepCandidates,
  uploadDocument,
  signPencatat,
  signKaIfrs,
  signApprover,
  getPdfUrl,
  getDrugCatalog,
  getActiveVersion,
  getDailyRekap,
  getDailyBreakdown,
  getMonthlyReport,
  getScorecard,
  getMyScorecard,
  getTrend,
};
